// Intentionally empty. Aliased over Next.js's internal
// `build/polyfills/polyfill-module` in next.config.ts.
//
// Next.js unconditionally ships that ~14 KiB module (Array.prototype.at/
// flat/flatMap, Object.fromEntries, Object.hasOwn, String.prototype.
// trimStart/trimEnd, Symbol.prototype.description, URL.canParse) in every
// build regardless of the project's `browserslist` config — it isn't part
// of the browserslist-driven differential-loading pipeline, so PSI/
// Lighthouse always flags it as "legacy JavaScript" even though every
// browser in our `browserslist` (chrome>=93, edge>=93, firefox>=92,
// safari>=15.4) natively supports all but one of these APIs.
//
// The one exception is `URL.canParse` (shipped in Chrome 120 / Firefox 115
// / Safari 17, later than our floor). Our own code never calls it, and it's
// not something Next's client runtime calls either as of the version this
// was added — see docs/LIGHTHOUSE_RESPONSE.md. If a future Next.js upgrade
// starts relying on it, that would surface as a `TypeError: URL.canParse is
// not a function` on older browsers; re-check this alias after upgrading.
//
// Tracking upstream: https://github.com/vercel/next.js/issues/86785
